module.exports = __webpack_public_path__ + "img/quickseofinal2.9c629d56.jpg";